// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__xR68x","halfSection":"Section_halfSection__4lnz2"};